import { ICourseCard } from 'components/molecules';
import { formatLessonStart } from 'services/LessonTimeService';

import { GroupEdge } from 'core/graphql';

export const transformCoursesNode = (edge: GroupEdge): ICourseCard | undefined => {
  const { node } = edge;
  if (node) {
    return {
      id: node.id,
      courseId: node.course.id,
      courseName: node.course.name,
      groupName: node.name,
      studentsCount: node.studentsCount || 0,
      courseImageURL: node.course.courseIcon || '',
      activeLessonNumber: node.passedLessonsCount || 0,
      lessonsCount: node.lessonsCount || 0,
      // ТЗ 0100: начало ближайшего занятия в поясе студента; нет занятия — ''.
      nextLesson: formatLessonStart(node.datetimeNextLesson),
      educationForm: node.course.educationForm || '',
      statusFinished: node.statusFinished || false,
    };
  }
};
